import { styled } from "@mui/system";
import Button from "@mui/material/Button";

import NewColors from "../themes/NewColors";

const MenuButton = styled(Button)(() => ({
  color: "black",
  fontFamily: "Lato",
  backgroundColor: NewColors.sectionBackground,
  background: NewColors.sectionBackground,
  fontWeight: "600",
  fontSize: "16",
  justifyContent: "left",
  width: "100%",
  borderRadius: 10,
  "&:hover": {
    backgroundColor: NewColors.triadicPower.primary,
    color: "white",
  },
}));

export default MenuButton;
